/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performResolutionObj: {},
  planType: [],
  rebateProgram: [],
  errorMsgActLabel: [],
  rebateProgramName: {},
  contactsDrop: [],
  contactsDropValue: '',
  contactsValue: 'Invoice',
  activeLabel: [],
  displayObj: {
    contactsDropValue: '',
    rebateProgramName: {},
    contactsValue: 'Invoice',
    activeLabel: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_ACTLABEL:
      return { ...state, performResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_ACTLABEL:
      return { ...state, resolutionDetailObj: action.detailScrData };

    case actionTypes.GET_ERROR_MSG_ACTLABEL:
      return { ...state, errorMsgActLabel: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_ACTLABEL:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_ACTLABEL:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_ACTLABEL:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.GET_CONTACTS_ACTLABEL:
      return { ...state, ...action.payload };
    case actionTypes.GET_CONTACTS_DROPDOWN:
      return { ...state, contactsDrop: action.payload };
    case actionTypes.GET_CONTACTS_DROPDOWN_NAME:
      return { ...state, ...action.payload };
    case actionTypes.SET_ACTIVE_LABELER_DATA:
      let displayObj = {
        ...state.displayObj,
        activeLabel: action.payload,
      };
      return { ...state, activeLabel: action.payload, displayObj };
    case actionTypes.SET_SELECTED_INPUT_ACTLABEL:
      return { ...state, ...action.payload };
    case actionTypes.SET_DISPLAY_OBJ_ACTLABEL:
      // let tempObj = {
      //   ...state.displayObj,
      //   rebateProgramName: {
      //     ...action.payload.rebateProgramName,
      //   },
      // };

      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };

    case actionTypes.SET_REFRESH_DATA_ACTLABEL:
      return {
        ...state,
        performResolutionObj: {},
        planType: [],
        rebateProgram: [],
        errorMsgActLabel: [],
        rebateProgramName: {},
        contactsDrop: [],
        contactsDropValue: '',
        contactsValue: 'Invoice',
      };
    case actionTypes.REFRESH_ACTIVE_LABELER_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};
export default reducer;
